import React, { memo, useMemo } from 'react';
import { LabelType, MyAnalyticsDimensionType } from 'graphql/types';
import { useGetMyAnalyticsData } from 'modules/Insights/Notes/hooks/useGetMyAnalyticsData';
import { transformLabelData } from './utils';
import ClientComponent from './ClientComponent';

export const ClientChart: React.FC = () => {
  const { data, loading = true, isEmpty } = useGetMyAnalyticsData(
    MyAnalyticsDimensionType.MetricsByClient
  );

  const dataset = useMemo(() => {
    if (isEmpty) {
      return [];
    } else {
      return transformLabelData(data?.myAnalytics?.items, LabelType.Client);
    }
  }, [data?.myAnalytics?.items, isEmpty]);

  return <ClientComponent data={dataset} loading={loading} isEmpty={isEmpty} />;
};
export default memo(ClientChart);
